/*--------------------------------------------------------------------------*
 * アコーディオン（検索BOX）
 *--------------------------------------------------------------------------*/
module Module_Acd {
	interface currentTab {
		tab?: JQuery,
		pnl?: JQuery,
	}

	export class Model_Acd {
		tab: JQuery;
		pnl: JQuery;

		constructor() {
			this.tab   = $('[data-acd="tab"]');
			this.pnl   = $('[data-acd="panel"]');
		}

		// 既に開いているタブを探す
		searchOpenTab(tab: JQuery): currentTab {
			let crnt: currentTab = {
				tab: null,
				pnl: null,
			};
			tab.each(function(): boolean {
				const _self: JQuery = $(this);
				if(_self.attr("aria-selected") === "true") {
					crnt["tab"] = _self;
					crnt["pnl"] = $("#"+_self.attr("aria-describedby"));
					return false;
				}
			});
			return crnt;
		}

		// アコーディオンの開閉
		moveAcdPnl(tab: JQuery, open: boolean, callback?: callbackType): void {
			const pnl: JQuery = $("#"+tab.attr("aria-describedby")),
				duration: number = 400;
			let crnt: currentTab;

			callback = callback ? callback : function(){};

			// 既に開いているタブを探す
			crnt = this.searchOpenTab(this.tab);

			// 開閉判別
			open = open ? open : pnl.attr("aria-hidden") === "true";

			// 開いているパネルを閉じる
			if(crnt.tab && crnt.pnl) {
				crnt.pnl.stop().slideUp(duration).attr("aria-hidden", "true");
				crnt.tab.prop("checked", false).attr("aria-selected", "false");
			}

			// クリックしたタブを開く
			if(open) {
				pnl.stop().slideDown(duration);
				tab.attr("aria-selected", "true");
				pnl.attr("aria-hidden", "false");
			}

			// コールバック関数の実行
			setTimeout(callback, duration);
		};
	}
}
